var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountManagementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_311_3018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.177 41.6398V35.5934C9.177 29.6543 13.9927 24.8345 19.9318 24.8345C23.3185 24.8345 26.3417 26.3998 28.3117 28.8448",
    stroke: "#276AE2",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0678 21.9361C29.4549 18.549 29.4549 13.0574 26.0678 9.67034C22.6807 6.28324 17.1892 6.28324 13.8021 9.67034C10.415 13.0574 10.415 18.549 13.8021 21.9361C17.1892 25.3232 22.6807 25.3232 26.0678 21.9361Z",
    stroke: "#276AE2",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7765 37.7327C33.8326 37.7327 34.6887 36.8765 34.6887 35.8204C34.6887 34.7643 33.8326 33.9082 32.7765 33.9082C31.7204 33.9082 30.8643 34.7643 30.8643 35.8204C30.8643 36.8765 31.7204 37.7327 32.7765 37.7327Z",
    stroke: "#27C3E2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.315 34.2553H37.4559C37.3816 34.0365 37.2948 33.8217 37.1916 33.6152L37.7987 33.0081C37.9969 32.8098 37.9969 32.4918 37.7987 32.2936L36.3036 30.7985C36.1054 30.6002 35.7873 30.6002 35.5891 30.7985L34.982 31.4056C34.7713 31.3023 34.5607 31.2115 34.3418 31.1413V30.2822C34.3418 30.0013 34.1147 29.7783 33.8379 29.7783H31.7233C31.4425 29.7783 31.2195 30.0055 31.2195 30.2822V31.1413C31.0006 31.2156 30.7858 31.3023 30.5793 31.4056L29.9722 30.7985C29.7739 30.6002 29.4559 30.6002 29.2577 30.7985L27.7626 32.2936C27.5643 32.4918 27.5643 32.8098 27.7626 33.0081L28.3697 33.6152C28.2664 33.8258 28.1756 34.0365 28.1054 34.2553H27.2463C26.9655 34.2553 26.7424 34.4825 26.7424 34.7592V36.8738C26.7424 37.1547 26.9696 37.3777 27.2463 37.3777H28.1054C28.1797 37.5966 28.2664 37.8114 28.3697 38.0179L27.7626 38.625C27.5643 38.8232 27.5643 39.1413 27.7626 39.3395L29.2577 40.8346C29.4559 41.0328 29.7739 41.0328 29.9722 40.8346L30.5793 40.2275C30.7899 40.3307 31.0006 40.4216 31.2195 40.4918V41.3509C31.2195 41.6317 31.4466 41.8547 31.7233 41.8547H33.8379C34.1188 41.8547 34.3418 41.6276 34.3418 41.3509V40.4918C34.5607 40.4175 34.7755 40.3307 34.982 40.2275L35.5891 40.8346C35.7873 41.0328 36.1054 41.0328 36.3036 40.8346L37.7987 39.3395C37.9969 39.1413 37.9969 38.8232 37.7987 38.625L37.1916 38.0179C37.2948 37.8072 37.3857 37.5966 37.4559 37.3777H38.315C38.5958 37.3777 38.8188 37.1505 38.8188 36.8738V34.7592C38.8188 34.4784 38.5917 34.2553 38.315 34.2553Z",
    stroke: "#276AE2",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_311_3018"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountManagementIcon);
export default __webpack_public_path__ + "static/media/AccountManagementIcon.0627342f572e80358504bb14e1f24792.svg";
export { ForwardRef as ReactComponent };